import { defineMessages } from 'react-intl';

export const aiSuggestionsMessages: {
	applyChangesButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardAcceptButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardAuthorsTooltipLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardBadSuggestionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardCloseButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardCollapseButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardCompareWithOriginalOptionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardDetailsButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardDiscardButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardDisclaimerText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardDismissButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardExpandButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardGoodSuggestionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardHideDeletedDiffsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardMoreOptionsButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardOnlyShowSuggestionOptionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardPrivateLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardPrivateTooltipLabelShort: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardRegeneratingBannerLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardRestrictedLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardRestrictedTooltipLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardRovoAuthorLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	/**
	 * @private
	 * @deprecated The suggestion card no longer displays a Rovo text label.
	 */
	cardRovoTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardScrollBackToSuggestionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardShowDeletedDiffsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardShowSidebarButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardSourcesButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardSourcesHideButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardSourcesShowButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardStaleBannerLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cardUpdatedBannerLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	contentReviewAgentPrompt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fetchSuggestionsButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fetchSuggestionsButtonLoadingLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	followUpCardDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	followUpCardReviewButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	followUpCardTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	iconButtonSuggestionsCountLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	labsLozengeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	originalViewLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	previewLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reviewNote: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sourceLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestEditsButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestEditsPromptPrefix: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestedLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestionsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestionsToolbarButtonErrorLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestionsToolbarButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestionsToolbarButtonLoadingLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	suggestionsToolbarButtonReadyLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingAnalyzingStructure: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCheckingConsistency: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCheckingRelatedSources: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCompleteClose: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCompleteNoSuggestions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCompleteNoSuggestionsUpdated: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCompleteReviewComplete: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCompleteReviewCompleteUpdated: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingCompleteViewSuggestions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingErrorTokenLimitExceeded: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingEscHint: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingEvaluatingOptions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingFinalizingSuggestionsForReview: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingGatheringContext: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingIdentifyingImprovements: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingMayTakeAFewMinutes: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingPreparingSuggestions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingRefiningSuggestions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingReviewingContent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingReviewingContentWithAgent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thinkingStopLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	viewLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	suggestEditsButtonLabel: {
		id: 'fabric.editor.ai.suggestions.suggestEditsButtonLabel',
		defaultMessage: 'Review',
		description: 'Label for the Suggest edits button in the editor toolbar',
	},
	suggestEditsPromptPrefix: {
		id: 'fabric.editor.ai.suggestions.suggestEditsPromptPrefix.non-final',
		defaultMessage: 'Review my content with ',
		description:
			'Localised text that precedes the suggest-edits skill tag in the prompt sent to the AI service. The trailing space is intentional — it separates this text from the skill tag that follows. Localise it in a way where the prompt ends with the skill tag. (With the skill tag it will look like e.g. "Review my content with /suggest-edits")',
	},
	contentReviewAgentPrompt: {
		id: 'fabric.editor.ai.suggestions.contentReviewAgentPrompt.non-final',
		defaultMessage: 'Review my content and suggest improvements',
		description:
			'The whole prompt sent to the AI service when the review is handled by the Content Reviewer agent. The agent already knows how to produce suggestions, so unlike suggestEditsPromptPrefix this is plain text with no skill tag appended.',
	},
	suggestionsToolbarButtonLabel: {
		id: 'fabric.editor.ai.suggestions.toolbarButton.label.non-final',
		defaultMessage: 'Suggestions',
		description: 'Label for the suggestions toolbar button',
	},
	suggestionsToolbarButtonLoadingLabel: {
		id: 'fabric.editor.ai.suggestions.toolbarButton.loadingLabel.non-final',
		defaultMessage: 'Loading',
		description: 'Label for the suggestions toolbar button when loading',
	},
	suggestionsToolbarButtonReadyLabel: {
		id: 'fabric.editor.ai.suggestions.toolbarButton.readyLabel.non-final',
		defaultMessage: 'View',
		description: 'Label for the suggestions toolbar button when ready',
	},
	suggestionsToolbarButtonErrorLabel: {
		id: 'fabric.editor.ai.suggestions.toolbarButton.errorLabel.non-final',
		defaultMessage: 'Retry',
		description: 'Label for the suggestions toolbar button when error',
	},
	previewLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.previewLabel.non-final',
		defaultMessage: 'Preview',
		description: 'The section title displayed for the AI suggestions staging area',
	},
	viewLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.viewLabel.non-final',
		defaultMessage: 'View',
		description:
			'The section title displayed for the view switcher in the AI suggestions staging area',
	},
	titleLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.titleLabel.non-final',
		defaultMessage: 'Title',
		description: 'The section title displayed for the title in the AI suggestions staging area',
	},
	reviewNote: {
		id: 'fabric.editor.ai.suggestions.stagingArea.reviewNote.non-final',
		defaultMessage: 'Review • Only visible to you',
		description:
			'The text is shown as a note within the staging area title bar during an AI suggestion review, indicating that the AI-generated content is only visible to the current user and has not been published.',
	},
	applyChangesButtonLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.applyChangesButtonLabel.non-final',
		defaultMessage: 'Apply changes',
		description: 'Label for the apply changes button in the AI suggestions staging area',
	},
	fetchSuggestionsButtonLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLabel.non-final',
		defaultMessage: 'Fetch suggestions',
		description: 'Label for the fetch suggestions button in the AI suggestions staging area',
	},
	fetchSuggestionsButtonLoadingLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLoadingLabel.non-final',
		defaultMessage: 'Loading…',
		description: 'Label for the fetch suggestions button when loading',
	},
	followUpCardTitle: {
		id: 'fabric.editor.ai.suggestions.followUpCard.title.non-final',
		defaultMessage: 'Review the rest?',
		description:
			'Title of the card shown in place of the AI suggestion card once the last suggestion has been actioned, offering to review the rest of the page',
	},
	followUpCardDescription: {
		id: 'fabric.editor.ai.suggestions.followUpCard.description.non-final',
		defaultMessage: 'Generate suggestions to improve the rest of your content.',
		description:
			'Body text of the card shown in place of the AI suggestion card once the last suggestion has been actioned',
	},
	followUpCardReviewButtonLabel: {
		id: 'fabric.editor.ai.suggestions.followUpCard.reviewButtonLabel.non-final',
		defaultMessage: 'Review',
		description:
			'Label for the review button on the card shown once the last AI suggestion has been actioned, which generates suggestions for the rest of the page',
	},
	iconButtonSuggestionsCountLabel: {
		id: 'fabric.editor.ai.suggestions.iconButton.suggestionsCountLabel.non-final',
		defaultMessage: '{count} suggestions',
		description:
			'Tooltip text for the suggestion icon button when there are multiple AI suggestions',
	},
	labsLozengeLabel: {
		id: 'fabric.editor.ai.suggestions.labsLozengeLabel.non-final',
		defaultMessage: 'Labs',
		description: 'Label for the Labs lozenge shown on AI suggestion cards and sidebar tabs',
	},
	originalViewLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.originalViewLabel.non-final',
		defaultMessage: 'Original • View only',
		description: 'Label for the original view in the AI suggestions staging area',
	},
	suggestedLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.suggestedLabel.non-final',
		defaultMessage: 'Suggested',
		description: 'Suggestion text displayed under the original view title',
	},
	suggestionsLabel: {
		id: 'fabric.editor.ai.suggestions.stagingArea.suggestionsLabel.non-final',
		defaultMessage: 'Suggestions',
		description: 'Label for the suggestions section in the AI suggestions staging area',
	},
	cardCloseButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.closeButtonLabel.non-final',
		defaultMessage: 'Close',
		description: 'Label for the close button on the AI suggestions card',
	},
	cardShowSidebarButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.showSidebarButtonLabel.non-final',
		defaultMessage: 'Show sidebar',
		description: 'Label for the show sidebar button on the AI suggestions card',
	},
	cardExpandButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.expandButtonLabel.non-final',
		defaultMessage: 'Expand',
		description: 'Label for the expand button on the AI suggestions card',
	},
	cardCollapseButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.collapseButtonLabel.non-final',
		defaultMessage: 'Collapse',
		description: 'Label for the collapse button on the AI suggestions card',
	},
	cardRovoTitle: {
		id: 'fabric.editor.ai.suggestions.card.rovoTitle.non-final',
		defaultMessage: 'Rovo',
		description: 'Deprecated title for Rovo branding on the AI suggestions card',
	},
	cardRovoAuthorLabel: {
		id: 'editor-common.ai-messages.ai-suggestions.cardRovoAuthorLabel',
		defaultMessage: 'Rovo',
		description: 'Accessible name and tooltip identity for suggestions without a named agent',
	},
	cardAuthorsTooltipLabel: {
		id: 'fabric.editor.ai.suggestions.card.authorsTooltipLabel.non-final',
		defaultMessage: '{agentName} with {userName}',
		description: 'Tooltip identifying the agent and user who authored an AI suggestion together',
	},
	cardPrivateLabel: {
		id: 'fabric.editor.ai.suggestions.card.privateLabel.non-final',
		defaultMessage: 'Private',
		description: 'Label for the private/lock indicator on the AI suggestions card',
	},
	cardPrivateTooltipLabelShort: {
		id: 'fabric.editor.ai.suggestions.card.privateTooltipLabelShort.non-final',
		defaultMessage: 'Visible only to you',
		description: 'Tooltip shown on the private indicator icon in the AI suggestions card',
	},
	cardRestrictedLabel: {
		id: 'fabric.editor.ai.suggestions.card.restrictedLabel.non-final',
		defaultMessage: 'Restricted',
		description: 'Label for the restricted suggestion lozenge',
	},
	cardRestrictedTooltipLabel: {
		id: 'fabric.editor.ai.suggestions.card.restrictedTooltip.non-final',
		defaultMessage: 'Only editors with access to the source can see this suggestion',
		description: 'Tooltip for the restricted suggestion lozenge',
	},
	cardDetailsButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.detailsButtonLabel.non-final',
		defaultMessage: 'Details',
		description: 'Label for the details toggle button on the AI suggestions card',
	},
	cardSourcesButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.sourcesButtonLabel.non-final',
		defaultMessage: 'Sources',
		description: 'Label for the sources toggle button on the AI suggestions card',
	},
	cardSourcesHideButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.sourcesHideButtonLabel.non-final',
		defaultMessage: 'Hide reasoning',
		description: 'Label for the sources toggle button when sources are expanded',
	},
	cardSourcesShowButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.sourcesShowButtonLabel.non-final',
		defaultMessage: 'Show reasoning',
		description: 'Label for the sources toggle button when sources are collapsed',
	},
	cardAcceptButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.acceptButtonLabel.non-final',
		defaultMessage: 'Accept',
		description: 'Label for the accept button on the AI suggestions card',
	},
	cardStaleBannerLabel: {
		id: 'fabric.editor.ai.suggestions.card.staleBannerLabel.non-final',
		defaultMessage: 'This suggestion is outdated.',
		description:
			'Banner shown at the top of the AI suggestions card when the suggestion is out of date (stale)',
	},
	cardRegeneratingBannerLabel: {
		id: 'fabric.editor.ai.suggestions.card.regeneratingBannerLabel.non-final',
		defaultMessage: 'Updating suggestion...',
		description:
			'Banner shown at the top of the AI suggestions card while the suggestion is being updated (regenerated)',
	},
	cardUpdatedBannerLabel: {
		id: 'fabric.editor.ai.suggestions.card.updatedBannerLabel.non-final',
		defaultMessage: 'Suggestion updated.',
		description:
			'Banner shown briefly at the top of the AI suggestions card after the suggestion has been successfully updated (regenerated)',
	},
	cardDiscardButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.discardButtonLabel.non-final',
		defaultMessage: 'Discard',
		description: 'Label for the discard button on the AI suggestions card',
	},
	cardDisclaimerText: {
		id: 'fabric.editor.ai.suggestions.card.disclaimerText.non-final',
		defaultMessage: 'Uses AI. Verify results.',
		description: 'Disclaimer text shown in the footer of the AI suggestions card',
	},
	cardDismissButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.dismissButtonLabel.non-final',
		defaultMessage: 'Dismiss',
		description: 'Label for the dismiss button on the AI suggestions card',
	},
	cardMoreOptionsButtonLabel: {
		id: 'fabric.editor.ai.suggestions.card.moreOptionsButtonLabel.non-final',
		defaultMessage: 'More options',
		description: 'Label for the overflow actions button on the AI suggestions card',
	},
	cardGoodSuggestionLabel: {
		id: 'fabric.editor.ai.suggestions.card.goodSuggestionLabel.non-final',
		defaultMessage: 'Good suggestion',
		description:
			'Label for the overflow menu item / button that submits positive (thumbs up) feedback on an AI suggestion',
	},
	cardBadSuggestionLabel: {
		id: 'fabric.editor.ai.suggestions.card.badSuggestionLabel.non-final',
		defaultMessage: 'Bad suggestion',
		description:
			'Label for the overflow menu item / button that submits negative (thumbs down) feedback on an AI suggestion',
	},
	cardOnlyShowSuggestionOptionLabel: {
		id: 'fabric.editor.ai.suggestions.card.onlyShowSuggestionOptionLabel.non-final',
		defaultMessage: 'Only show suggestion',
		description: 'Label for the dropdown action to only show the selected suggestion',
	},
	cardCompareWithOriginalOptionLabel: {
		id: 'fabric.editor.ai.suggestions.card.compareWithOriginalOptionLabel.non-final',
		defaultMessage: 'Compare with original',
		description: 'Label for the dropdown action to compare suggestion with original content',
	},
	cardHideDeletedDiffsLabel: {
		id: 'fabric.editor.ai.suggestions.card.hideDeletedDiffsLabel.non-final',
		defaultMessage: 'Hide comparison',
		description:
			'Tooltip label for the eye icon button on the AI suggestions card when deleted diffs are visible',
	},
	cardShowDeletedDiffsLabel: {
		id: 'fabric.editor.ai.suggestions.card.showDeletedDiffsLabel.non-final',
		defaultMessage: 'Show comparison',
		description:
			'Tooltip label for the eye icon button on the AI suggestions card when deleted diffs are hidden',
	},
	cardScrollBackToSuggestionLabel: {
		id: 'fabric.editor.ai.suggestions.card.scrollBackToSuggestionLabel.non-final',
		defaultMessage: 'Back to suggestion',
		description: 'Label for the scroll back to suggestion button on the AI suggestions card',
	},
	thinkingEscHint: {
		id: 'fabric.editor.ai.suggestions.thinking.escHint.non-final',
		defaultMessage: 'Esc',
		description: 'Keyboard hint showing the Esc key can be used to cancel',
	},
	thinkingStopLabel: {
		id: 'fabric.editor.ai.suggestions.thinking.stopLabel.non-final',
		defaultMessage: 'Stop',
		description:
			'Accessible label for the stop button displayed while the AI is thinking. When clicked, it cancels the ongoing action.',
	},
	thinkingReviewingContent: {
		id: 'fabric.editor.ai.suggestions.thinking.reviewingContent.non-final',
		defaultMessage: 'Reviewing content',
		description: 'Loading message shown while the AI is reviewing the content',
	},
	thinkingReviewingContentWithAgent: {
		id: 'fabric.editor.ai.suggestions.thinking.reviewingContentWithAgent.non-final',
		defaultMessage: 'Reviewing content with {agentName}',
		description:
			'First loading message on the AI suggestions thinking bar. The {agentName} placeholder is replaced with the reviewing agent name (for example "Content Reviewer"). Shown for a few seconds before the remaining rotating statuses.',
	},
	thinkingMayTakeAFewMinutes: {
		id: 'fabric.editor.ai.suggestions.thinking.mayTakeAFewMinutes.non-final',
		defaultMessage: 'This may take a few minutes',
		description: 'Loading message setting expectations that the AI review may take a few minutes',
	},
	thinkingAnalyzingStructure: {
		id: 'fabric.editor.ai.suggestions.thinking.analyzingStructure.non-final',
		defaultMessage: 'Analyzing structure',
		description: 'Loading message shown while the AI is analyzing the content structure',
	},
	thinkingCheckingRelatedSources: {
		id: 'fabric.editor.ai.suggestions.thinking.checkingRelatedSources.non-final',
		defaultMessage: 'Checking related sources',
		description: 'Loading message shown while the AI is checking related sources',
	},
	thinkingGatheringContext: {
		id: 'fabric.editor.ai.suggestions.thinking.gatheringContext.non-final',
		defaultMessage: 'Gathering context',
		description: 'Loading message shown while the AI is gathering context',
	},
	thinkingIdentifyingImprovements: {
		id: 'fabric.editor.ai.suggestions.thinking.identifyingImprovements.non-final',
		defaultMessage: 'Identifying improvements',
		description: 'Loading message shown while the AI is identifying improvements',
	},
	thinkingEvaluatingOptions: {
		id: 'fabric.editor.ai.suggestions.thinking.evaluatingOptions.non-final',
		defaultMessage: 'Evaluating options',
		description: 'Loading message shown while the AI is evaluating possible suggestions',
	},
	thinkingCheckingConsistency: {
		id: 'fabric.editor.ai.suggestions.thinking.checkingConsistency.non-final',
		defaultMessage: 'Checking consistency',
		description: 'Loading message shown while the AI is checking content consistency',
	},
	thinkingPreparingSuggestions: {
		id: 'fabric.editor.ai.suggestions.thinking.preparingSuggestions.non-final',
		defaultMessage: 'Preparing suggestions',
		description: 'Loading message shown while the AI is preparing suggestions',
	},
	thinkingRefiningSuggestions: {
		id: 'fabric.editor.ai.suggestions.thinking.refiningSuggestions.non-final',
		defaultMessage: 'Refining suggestions',
		description: 'Loading message shown while the AI is refining suggestions',
	},
	thinkingFinalizingSuggestionsForReview: {
		id: 'fabric.editor.ai.suggestions.thinking.finalizingSuggestionsForReview.non-final',
		defaultMessage: 'Finalizing suggestions for review',
		description: 'Loading message shown while the AI is finalizing suggestions for review',
	},
	thinkingCompleteReviewComplete: {
		id: 'fabric.editor.ai.suggestions.thinkingComplete.reviewComplete.non-final',
		defaultMessage: 'Suggestions ready',
		description: 'Text shown when the AI has finished reviewing the content',
	},
	thinkingCompleteReviewCompleteUpdated: {
		id: 'fabric.editor.ai.suggestions.thinkingComplete.reviewCompleteUpdated.non-final',
		defaultMessage: 'Review complete, view your suggestions.',
		description: 'Updated text shown when the AI has finished reviewing the content',
	},
	thinkingCompleteNoSuggestions: {
		id: 'fabric.editor.ai.suggestions.thinkingComplete.noSuggestions.non-final',
		defaultMessage: 'No suggestions found',
		description:
			'Text shown when the AI has finished reviewing the content and no suggestions were found',
	},
	thinkingCompleteNoSuggestionsUpdated: {
		id: 'fabric.editor.ai.suggestions.thinkingComplete.noSuggestionsUpdated.non-final',
		defaultMessage: 'Review complete. No suggestions found.',
		description:
			'Updated text shown when the AI has finished reviewing the content and no suggestions were found',
	},
	thinkingCompleteViewSuggestions: {
		id: 'fabric.editor.ai.suggestions.thinkingComplete.viewSuggestions.non-final',
		defaultMessage: 'View',
		description: 'Label for the button that opens the suggestions panel',
	},
	thinkingCompleteClose: {
		id: 'fabric.editor.ai.suggestions.thinkingComplete.close.non-final',
		defaultMessage: 'Close',
		description: 'Accessible label for the close button on the thinking complete bar',
	},
	thinkingErrorTokenLimitExceeded: {
		id: 'fabric.editor.ai.suggestions.thinkingError.tokenLimitExceeded.non-final',
		defaultMessage: 'There’s too much content to process.',
		description:
			'Error shown on the suggested-edits thinking bar when the request exceeds the maximum content limit.',
	},
	sourceLabel: {
		id: 'fabric.editor.ai.suggestions.sourceLabel.non-final',
		defaultMessage: 'Teamwork Graph',
		description: 'Label for the Teamwork Graph sources section on the AI suggestions card',
	},
});
